/*const variable for Restservice calls - key table values */
// value came from AddressRestDtoFactroy,represents class type Postadress
export const POST_ADDRESS = 100;
// enum for EMail (s.o. EMail.java)
export const EMAIL_ADDRESS = 10;
// enum for Phone (s.o. Phone.jva)
export const PHONE_ADDRESSES = [5, 6, 7];
// enum for Web (s.o. Hyperlink.java)
export const WEB_ADDRESSES = [8, 9];
// enum for Room
export const ROOM_ADDRESS = 101;
